module.exports = __webpack_public_path__ + "static/img/sox1.3045e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/furnitures/sox1.jpg
// module id = SDj4
// module chunks = 0